import { render, staticRenderFns } from "./range-payment.vue?vue&type=template&id=18eb0f78&"
import script from "./range-payment.vue?vue&type=script&lang=js&"
export * from "./range-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangeSlider: require('/var/www/components/range/range-slider.vue').default})
